import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreatedHolidayResponse,
  HolidayDetailsDto,
  HolidayFilterOptionsDto,
  HolidayListFilters,
  HolidayListItemDto,
  PaginationResult,
  UpsertHolidayRequest,
} from '../../shared/models/holiday';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class HolidayService extends AppSettingsService {
  private readonly basePath = `${this.apiUrl}/api/holiday`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getList(filters: HolidayListFilters) {
    let params = new HttpParams()
      .set('page', String(filters.page))
      .set('pageSize', String(filters.pageSize))
      .set('orderBy', filters.orderBy);

    if (filters.search.trim()) {
      params = params.set('search', filters.search.trim());
    }

    filters.types.forEach((type) => {
      params = params.append('types', type);
    });

    filters.states.forEach((state) => {
      params = params.append('states', state);
    });

    filters.cityIbgeCodes.forEach((cityIbgeCode) => {
      params = params.append('cityIbgeCodes', String(cityIbgeCode));
    });

    return this.http.get<PaginationResult<HolidayListItemDto>>(this.basePath, { params });
  }

  getById(id: number) {
    return this.http.get<HolidayDetailsDto>(`${this.basePath}/${id}`);
  }

  getFilterOptions(states?: string[]) {
    let params = new HttpParams();

    (states ?? []).forEach((state) => {
      params = params.append('states', state);
    });

    return this.http.get<HolidayFilterOptionsDto>(`${this.basePath}/filter-options`, { params });
  }

  create(payload: UpsertHolidayRequest) {
    return this.http.post<CreatedHolidayResponse>(this.basePath, payload);
  }

  update(id: number, payload: UpsertHolidayRequest) {
    return this.http.put<void>(`${this.basePath}/${id}`, payload);
  }

  delete(id: number) {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }
}
